module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10K4oGp/tc-custom/9781488060052.jpg?1725723335717",
      "alt": "This image is the cover for the book Cowboy's Unexpected Baby, Triple Creek Cowboys"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cowboy's Unexpected Baby, Triple Creek Cowboys\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("From bachelorhood to fatherhood…in an instant!"), _c('br'), _c('br'), _c('b', [_vm._v("First comes baby, then comes…")]), _c('b', [_c('i', [_vm._v("love")])]), _c('b', [_vm._v("?Now this cowboy is in over his head.")]), _c('br'), _c('br'), _vm._v("Rancher and lawyer Garrett Cole wants a family—eventually. Until he finds a sweet newborn abandoned on his doorstep. If it weren’t for Abby Scott, the social worker temporarily working in his office, he’d be lost. But when their attraction grows deeper, can this cowboy dad risk his heart on a woman who might not be in town for good?"), _c('br'), _c('br'), _c('b', [_c('i', [_vm._v("Triple Creek Cowboys")])])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephanie Dees\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Award-winning author Stephanie Dees lives in small-town Florida with her pastor husband and their two youngest children. A Southern girl through and through, she loves sweet tea, SEC football, corn on the cob and air-conditioning. For further information, please visit her website at stephaniedees.com."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0